import request from '@/utils/request'
import { mapValues } from 'lodash-es'
import { DateRangeValue } from '@/components/date/date.types'
import {
  HistoryUserLogReq,
  HistoryUserLogReqParams,
  HistoryUserLogRes,
  InterfaceHistoryParams,
  InterfaceHistoryReq,
  InterfaceHistoryRes,
} from '@/services/history/history.types'

// 폼은 yyyyMMdd 문자열을, 비우면 '' 를 넣는다. 빈 값은 키를 빼고 보낸다 — BE 가 기간 누락 400("plnDateFrom 은 필수입니다" 등)을 준다
const toDateParam = (value: DateRangeValue[number]) => (typeof value === 'string' && value ? value : undefined)

export const getInterfaceHistory = ({ plnDate: [plnDateFrom, plnDateTo], ...rest }: InterfaceHistoryParams) =>
  request.get<InterfaceHistoryRes, InterfaceHistoryReq>('/api/v1/history/interface-logs', {
    // request.get 의 qsStringify 는 encode: false 다 — 기간 외 쿼리 값을 전부 여기서 인코딩한다(apiNo 등 자유 입력의 & # % 가 URL 을 깨지 않게)
    ...mapValues(rest, (value) => encodeURIComponent(value)),
    plnDateFrom: toDateParam(plnDateFrom),
    plnDateTo: toDateParam(plnDateTo),
  })

const getUserAccessLogs =
  (url: string) =>
  ({ evtDate: [evtDateFrom, evtDateTo], email, menuCd }: HistoryUserLogReqParams) =>
    request.get<HistoryUserLogRes, HistoryUserLogReq>(url, {
      // 이메일의 + 가 서버에서 공백으로 읽히지 않게 인코딩한다(qsStringify 는 encode: false)
      email: encodeURIComponent(email),
      menuCd: encodeURIComponent(menuCd),
      evtDateFrom: toDateParam(evtDateFrom),
      evtDateTo: toDateParam(evtDateTo),
    })

export const getHistoryUserLog = getUserAccessLogs('/api/v1/history/user-access-logs')
export const getHistoryDownloadLog = getUserAccessLogs('/api/v1/history/download-logs')
